import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesPrioritiesDefaultRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-priorities-default',
	path: '/secure/admin/MakeDefaultPriority([!%]?[\\w]*).jspa',
};
